<template>
  <div class="loader-cont">
    <section class="network-problem">
      <div class="network-problem__content">
        <h1>{{ getTranslations.home_please_refresh_whoops }}<br>{{ getTranslations.home_please_refresh_check_connection }}</h1>
        <img src="static/images/no_connection.svg" alt="">
        <p>{{ getTranslations.home_please_refresh_session_timeout }}</p>
        <a style="cursor:pointer" class="btn2 btn2--std btn2--small btn2--green" @click.prevent="refreshPageProgrammatically">{{ getTranslations.home_please_refresh_try_again }}</a>
      </div>
    </section>
  </div>
</template>

<script>
/* eslint no-console: "off" */
import { mapGetters } from 'vuex';

export default {
  name: 'please-refresh',
  methods: {
    refreshPageProgrammatically() {
      window.location.reload();
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/PleaseRefresh.vue